import moment from 'moment'

import { localStorageFeatureToggle } from '../../utils/feature-toggle-utils'

import type { Collaborator, ConversationTimelineItem } from './types'

export const formatMessageText = (
  messageText: string,
  collaborators: Collaborator[],
  textOnly = false
): string => {
  // eslint-disable-next-line no-useless-escape
  const regex = /@[\[]\w+[\]]/gm
  return messageText.replace(regex, (match) => {
    const collaborator = collaborators.find((collab: Collaborator) =>
      match.includes(collab._id)
    )
    const name = collaborator ? `${collaborator.username || ''}` : 'unknown'
    if (!textOnly && localStorageFeatureToggle.get('CaptionV2')) {
      const displayName = collaborator
        ? `${collaborator.firstName || ''} ${collaborator.lastName || ''}`.trim()
        : 'unknown'
      return `<span class="text-blue-500 font-semibold">${displayName}</span>`
    }
    return textOnly
      ? `@${name}`
      : `<span class="text-[#4f31ff]">@${name}</span>`
  })
}

export const sortMessagesByDate = (
  messages: ConversationTimelineItem[]
): ConversationTimelineItem[] => {
  return [...messages].sort(
    (message, nextMessage) =>
      moment(new Date(message?.createdAt)).unix() -
      moment(new Date(nextMessage?.createdAt)).unix()
  )
}

export const getLastStatusChangeMessage = (
  messages?: ConversationTimelineItem[]
): ConversationTimelineItem | null => {
  if (!messages || messages.length === 0) {
    return null
  }

  const statusChangeMessages = messages.filter(
    (msg) => msg.variant === 'statusChange'
  )
  if (statusChangeMessages.length === 0) {
    return null
  }
  const sortedMessages = sortMessagesByDate(statusChangeMessages)

  return sortedMessages[sortedMessages.length - 1] || null
}

export const checkIsReplied = (
  status?: string,
  messages?: ConversationTimelineItem[]
): boolean => {
  if (status !== 'requestChange' || !messages || messages.length === 0) {
    return false
  }

  const lastMessage = getLastStatusChangeMessage(messages)

  return Boolean(
    lastMessage &&
    lastMessage.isMessageOwner &&
    lastMessage.comment &&
    lastMessage.comment.trim().length > 0
  )
}

export const scrollToBottomOfConversation = (): void => {
  const conversationWrapElem = document.getElementById('conversation_wrap')
  if (conversationWrapElem) {
    conversationWrapElem.scrollTop = conversationWrapElem.scrollHeight
  }
}

export const toCapitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
